import { useMemo } from 'react';
import { useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { ActionHeader, FaqLink } from '..';
import en from '../../../../lang/en-us';
import { SubmitButton } from '../../../../lib/Button';
import { GENERAL } from '../../../../utils/constants';
import { DOCUMNENTS } from '../../../quick-links/TransmissionRequest/transmission-download-list';
import { HistoryStateProps, TransmissonRowData } from './list';
import { OTP_ACTIONS } from '../../../../utils/constants';
const { dashboard } = en;

export interface TransmissionDownloadProps
    extends RouteComponentProps<any, any, HistoryStateProps> {
    children?: JSX.Element;
}

type TransmissionInfo = {
    amc: string;
    amcName: string;
    funds: TransmissonRowData[];
};

// const forms: DOCUMNENTS[] = [
//     {
//         description:
//             'Death Certificate original or Death certificate Photocopy duly attested by a Notary Public or Gazetted Officer',
//     },
//     {
//         title: 'T-3 Form',
//         description: 'Duly filled in and Signed Form T-3 << T-3 Form to be enclosed >>',
//         download: true,
//     },
// ];

// const NomineeForm: DOCUMNENTS = {
//     title: 'Nomination Form',
// };

export function PostTransmissionDownload(props: any) {
    const { targetFunds = [] } = props.location.state || {};
    useEffect(() => {
        if (!targetFunds) {
            return props.history.push('/');
        }
    }, []);

    const amcData = useMemo((): TransmissionInfo[] => {
        return targetFunds.reduce((prev: TransmissionInfo[], curr: any) => {
            const index = prev.findIndex((fund) => fund.amc === curr.amc);
            if (index !== -1) {
                prev[index].funds = [...prev[index].funds, curr];
            } else {
                prev = [...prev, { amc: curr.amc, amcName: curr.amcName, funds: [curr] }];
            }
            return prev;
        }, []);
    }, [targetFunds]);

    const handleSubmit = () => {
        props.history.replace('/portal/nct/transmission-download-otp', {
            ...props.location.state,
        });
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.TransmissionRequest.TransmissionRequestHeading} />
            <div className="curved-bg-content curved-bg-table-outer transmission-request transmission-download-list">
                <div className="curved-bg-content-inner">
                    <div className="transmission-download-content">
                        <div className="transmission-download-content-top post-transmission-list">
                            <img
                                className="transmission-download-character"
                                src="/images/transmission-download-character.png"
                                alt=""
                            />
                            <p>{dashboard.TransmissionRequest.downloadList.TransmissionInfo}</p>
                            <img src="/images/transmission-download-building.png" alt="" />
                        </div>
                        <div className="transmission-download-content-bottom new-ui">
                            {amcData.map((ele, index) => (
                                <div key={ele.amc} className="transmission-funds-content">
                                    <h4>{`${index + 1}. ${ele.amcName}`}</h4>
                                    <div className="transmission-funds-info">
                                        <div className="transmission-funds-left">
                                            <h5>Folios</h5>
                                            <div className="transmission-tags">
                                                {ele.funds.map((fund) => (
                                                    <p key={fund.id + ele.amc}>{fund.id}</p>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="transmission-funds-right">
                                            <h5>Documents Requirement</h5>
                                            <div className="transmission-download-list-documents">
                                                <div className="transmission-download-list-number">
                                                    <p>
                                                        <img src="/images/document-bg.svg" alt="" />
                                                        <span>1</span>
                                                    </p>
                                                </div>
                                                <div className="transmission-download-list-txt">
                                                    <h5>
                                                        Filled in T-1 Form (Mandatory){' '}
                                                        <span
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => {
                                                                window.open(
                                                                    `${process.env.REACT_APP_S3_CLOUD_URL}/T1Form.pdf`,
                                                                    '_system',
                                                                );
                                                            }}
                                                        >
                                                            Download
                                                        </span>
                                                    </h5>
                                                </div>
                                            </div>
                                            <div className="transmission-download-list-documents">
                                                <div className="transmission-download-list-number">
                                                    <p>
                                                        <img src="/images/document-bg.svg" alt="" />
                                                        <span>2</span>
                                                    </p>
                                                </div>
                                                <div className="transmission-download-list-txt">
                                                    <h5>Copy of Death Certificate (Mandatory)</h5>
                                                </div>
                                            </div>
                                            <div className="transmission-download-list-documents">
                                                <div className="transmission-download-list-number">
                                                    <p>
                                                        <img src="/images/document-bg.svg" alt="" />
                                                        <span>3</span>
                                                    </p>
                                                </div>
                                                <div className="transmission-download-list-txt">
                                                    <h5>
                                                        Nomination form (Optional, based on choice
                                                        made in T-1 Form)
                                                        <span
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => {
                                                                window.open(
                                                                    `${process.env.REACT_APP_S3_CLOUD_URL}/NominationForm.pdf`,
                                                                    '_system',
                                                                );
                                                            }}
                                                        >
                                                            Download
                                                        </span>
                                                    </h5>
                                                </div>
                                            </div>
                                            <div className="transmission-download-list-documents">
                                                <div className="transmission-download-list-number">
                                                    <p>
                                                        <img src="/images/document-bg.svg" alt="" />
                                                        <span>4</span>
                                                    </p>
                                                </div>
                                                <div className="transmission-download-list-txt">
                                                    <h5>
                                                        Bank Mandate form (Optional, based on choice
                                                        made in T-1 Form)
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <FaqLink section={GENERAL} history={props.history} />
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButton
                            onClick={handleSubmit}
                            label={dashboard.TransmissionRequest.downloadList.doneBtn}
                            className="customBtn"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
